import type { IBrandConfig } from './types';

const DEFAULT_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: '/policy/privacy-policy',
  termsOfService: '/terms/service-terms-of-use',
  vaultProject: 'identity_guard',
  licensor: 'intersections',
  adaChat: false,
  accountDetails: true,
  secureUpload: true,
  plan: true,
  security: true,
  missingPII: true,
  finishSetup: true,
  showTheftText: true,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'Intersections LLC dba Pango. All rights reserved.',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: null,
  carouselBanners: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      active: true,
      customerSupport: true,
      availability: (
        <>
          Monday - Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default DEFAULT_BRAND_CONFIG;
